<mat-dialog-content style="max-height: 80vw;max-width: none;">

  <div id="w3l-appointment">
  <section class="w3l-form-25">
            <h1 style="text-align: center;">{{'Treatment by Cairo cure' | translate }}</h1>

  <div id="w3l-appointment">
    <div class="top-header">
      <div class="d-grid grid-columns-top-3">
          <div class="accounts" style="left: 50px;">
            <div class="appointment-form-field">
              <label style="font-size: large;font-weight: bold;left: 150px;">     </label>

              <label style="font-size: large;font-weight: bold;left: 50px;">{{patientcode}}</label>
              <label style="font-size: large;font-weight: bold;left: 150px;">     </label>
              <label style="font-size: large;font-weight: bold;left: 190px;">{{patientname}}</label>
            </div>
            <ul>
              <label style="font-size: large;font-weight: bold;left: 150px;">     </label>

              <label style="font-size: large;font-weight: bold;">Date :{{trdate}}</label>
              <label style="font-size: large;font-weight: bold;">     </label>
              <label style="font-size: large;font-weight: bold;">{{trtime}}</label>
            </ul>
          </div>
      </div>
  </div>
  <mat-divider></mat-divider>
  <div class="wrapper appointment-form-field">
      <label style = "width: 15%;">Date </label>
      <input type="date" name="site" [(ngModel)]="trdate" style="width: 20%;" required="" />
      <label style = "width: 20%;"></label>
      <label style = "width: 10%;">Location </label>
      <select id="PatientStatus" name="PatientStatus" [(ngModel)]="trlocation" style="width: 29%;background-color:  rgb(187, 203, 238);"  required>
        <option value="{{doc.compCode}}"  *ngFor="let doc of companyList; let i = index">{{doc.compName}}</option>
      </select>
  </div>
  <div class="wrapper appointment-form-field">
    <label style = "width: 15%;">Treatment Type </label>
    <select id="PatientStatus" name="PatientStatus" [(ngModel)]="trtype" style="width: 20%;background-color:  rgb(187, 203, 238);" (change)="Change_Treatment_Type()" required>
      <option value="">Select*</option>
      <option value="1">Systemic Therapy</option>
      <option value="2">Radiotherapy</option>
      <!-- <option value="3">Hormonal Treatment</option> -->
      <option value="4">Surgery</option>
      <!-- <option value="5">Targeted Treatment</option>
      <option value="6">Immunotherapy</option> -->

  </select>
  <label style = "width: 20%;"></label>
  <label style = "width: 10%;">Consultant </label>
  <select id="trconsultant" name="trconsultant" [(ngModel)]="trconsultant" style="width: 29%;background-color:  rgb(187, 203, 238);"  required>
    <option value="{{cls.docCode}}" *ngFor="let cls of doctorsList; let i = index">{{cls.docName}}</option>
</select>
</div>
  <BR>
<!-- *********** Start For the 12 Cancer Types Line 1************** -->

<!-- ---------- End For the 12 Cancer Types  Line 1 --------------- -->
<!-- **************** Start If Chemoterapy TTT ******************** -->
<table *ngIf="!heddin_cycleno" style="width: 1200px;">
  <thead>
      <tr>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 20%;">Drug</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 7%;">Unit</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 6%;">Dose</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 6%;">Dose Modif. %</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 6%;">Cycle No.</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 6%;">Day of Cycle</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 27%;">{{TreatmentNotes}}</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 13%;">Start Date</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 9%;">Select</th>

      </tr>
  </thead>
  <tbody>

    <tr *ngFor="let pro of chemolist; let i = index" style="height: 50%;">
      <td data-column="Patient ID" >{{pro.trkind}}</td>
      <td data-column="Patient unit">{{pro.trunitname}}</td>
      <td data-column="Patient dos">{{pro.trdose}}</td>
      <td data-column="Patient dosmod">{{pro.trdosemod}}</td>
      <td data-column="Patient cyclno">{{pro.trcycleno}}</td>
      <td data-column="Patient cycleday">{{pro.trdayscycle}}</td>
      <td data-column="Patient Notes">{{pro.trnotes}}</td>
        <td data-column="Patient date">{{pro.trstartdate}}</td>
         <button name="BDrug" placeholder = "0" style="width: 50%;height: 35px;border-radius: 10%;color: rgb(2, 2, 114);" class="fa fa-pencil" required (click)="SelectChemo(pro)"></button>
         <button name="BDrugn" placeholder = "0" style="width: 50%;height: 35px;border-radius: 10%;color: rgb(178, 0, 0)" class="fa fa-trash" required (click)="MesgDeleteLine(pro)"></button>

        </tr>
  </tbody>
</table>
<div  *ngIf="!heddin_cycleno" class="styled-input" style="width: 1200px;">
  <div class="appointment-form-field"  style="width: 1200px;background-color: rgb(147, 147, 255);">
    <!-- <input type="text" name="SurgDate"  required="" style="width: 20%;" [(ngModel)]= "trkind"/> -->
    <select id="department" name="unit" required="" style="width: 20%;" [(ngModel)]="trkindid" [value]="trkindid" (change)="Get_ItemName()">
      <option value="{{unit.itCode}}" *ngFor="let unit of itemsList2; let i = index">{{unit.itTName}}</option>
    </select>
    <select id="department" name="unit" required="" style="width: 7%;" [(ngModel)]="trunit">
      <option value="{{unit.unCode}}" *ngFor="let unit of unitsList; let i = index">{{unit.unName}}</option>
    </select>
    <input type="number" name="dos" style="width: 6%;" [(ngModel)]= "trdose" />
    <input type="number" name="dosmod" style="width: 6%;" [(ngModel)]= "trdosemod" />
    <input type="number" name="Doctorcycleno" style="width: 6%;" [(ngModel)]= "trcycleno" />
    <input type="number" name="Doctorcyclday" style="width: 6%;" [(ngModel)]= "trdayscycle" />
    <input type="textarea" name="Doctornotes" style="width: 27%;" [(ngModel)]= "trnotes" />
    <input type="date" name="Doctdate" style="width: 13%;" [(ngModel)]= "trstartdate" />
    <button name="BDrug" placeholder = "0" class="fa fa-floppy-o" style="color: rgb(2, 2, 114); width: 4.5%;height: 100%;border-radius: 10%;" (click)="submitCMedication()" required></button>
    <button name="BDrug1" placeholder = "0" class="fa fa-trash-o" style="color: rgb(178, 0, 0); width: 4.5%;height: 100%;border-radius: 10%;" (click)="MesgDelete()" required></button>
  </div>
</div>
<!-- ---------- End If Chemoterapy TTT --------------- -->

<!-- **************** Start If Radiotherapy TTT ******************** -->
<table *ngIf="!heddin_frac" style="width: 1400px;">
  <thead>
      <tr>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;">Intention of Treatment</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 7.5%;">Technique</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;">Site</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 15%;">{{TreatmentNotes}}</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 12%;">Start Date</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 12%;">End Date</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;">Prev.Site</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 8%;">Concomitant Treatment</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 7%;">Total Dose (Gy)</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;">Fractionation</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 7%;">Dose per Fraction (Gy)</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;">Select</th>

      </tr>
  </thead>
  <tbody>

    <tr *ngFor="let pro of radiolist; let i = index" style="height: 50%;">
      <td data-column="Patient ID" >{{pro.trkind}}</td>
      <td data-column="trkindid" >{{pro.trkindid}}</td>
      <td data-column="Patient CycleNo" >{{pro.trcycleno}}</td>
      <td data-column="Patient notes">{{pro.trnotes}}</td>
      <td data-column="Patient sdos">{{pro.trstartdate}}</td>
      <td data-column="Patient edos">{{pro.trenddate}}</td>
      <td data-column="Patient Unit" >{{pro.trunit}}</td>
      <td data-column="Patient daycycl" >{{pro.trdayscycle}}</td>
      <td data-column="Patient dosmod">{{pro.trdose}}</td>
      <td data-column="Patient cyclno">{{pro.trfrac}}</td>
      <td data-column="Patient cycleday">{{pro.trdosefrac}}</td>

        <td data-column="Patient date">
          <button name="BDrug" placeholder = "0" style="width: 50%;height: 35px;border-radius: 10%;color: rgb(2, 2, 114);" class="fa fa-pencil" required (click)="SelectChemo(pro)"></button>
          <button name="BDrugn" placeholder = "0" style="width: 50%;height: 35px;border-radius: 10%;color: rgb(178, 0, 0)" class="fa fa-trash" required (click)="MesgDeleteLine(pro)"></button>
        </td>

        </tr>
  </tbody>
</table>
<div  *ngIf="!heddin_frac" class="styled-input" style="width: 1400px;">
  <div class="appointment-form-field"  style="width: 1400px;background-color: rgb(147, 147, 255);">
      <select id="trrkind" name="trrkind" required="" style="width: 10%;" [(ngModel)]="trkind" [value]="trkind">

      <option value="Postoperative">Postoperative</option>
      <option value="Radical" >Radical</option>
      <option value="Palliative" >Palliative</option>
    </select>
    <select id="kindid" name="kindid" required="" style="width: 7.5%;" [(ngModel)]="trkindid" [value]="trkindid" >
      <option value="{{unit.prHdName}}" *ngFor="let unit of protocolHD; let i = index">{{unit.prHdName}}</option>
    </select>
    <input type="text" name="cycleno" style="width: 10%;" [(ngModel)]= "trcycleno" />
    <input type="text" name="notes" style="width: 15%;" [(ngModel)]= "trnotes" />
    <input type="date" name="dosmod" style="width: 10%;" [(ngModel)]= "trstartdate" />
    <input type="date" name="doesmod" style="width: 10%;" [(ngModel)]= "trenddate" />
    <input type="tex" name="unit" style="width: 10%;" [(ngModel)]= "trunit" />
    <select id="daycycl" name="daycycl" required="" style="width: 8%;" [(ngModel)]="trdayscycle" >
      <option value="Chemotherapy" >Chemotherapy</option>
      <option value="Immunotherapy" >Immunotherapy</option>
      <option value="Both" >Chemo/Immuno</option>
    </select>
    <input type="number" name="dos" style="width: 7%;" [(ngModel)]= "trdose" />
    <input type="number" name="frac" style="width: 10%;" [(ngModel)]= "trfrac" />
    <input type="number" name="dosfrac" style="width: 7%;" [(ngModel)]= "trdosefrac" />
    <button name="BDrug" placeholder = "0" class="fa fa-floppy-o" style="color: rgb(2, 2, 114); width: 5%;height: 100%;border-radius: 10%;" (click)="submitRadio()" required></button>
    <button name="BDrug1" placeholder = "0" class="fa fa-trash-o" style="color: rgb(178, 0, 0); width: 5%;height: 100%;border-radius: 10%;" (click)="MesgDelete()" required></button>
  </div>
</div>
<!-- ---------- End If Radiotherapy TTT --------------- -->
<!-- **************** Start If Hormonal TTT ******************** -->
<table *ngIf="!heddin_hormonal" style="width: 1200px;">
  <thead>
      <tr>

          <th style="background-color:  rgb(70, 70, 247);color: white;width: 20%;">Type</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 50%;">Notes</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 20%;">Start Date</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;">Select</th>

      </tr>
  </thead>
  <tbody>

    <tr *ngFor="let pro of hormonallist; let i = index" style="height: 50%;">
      <td data-column="Patient ID" >{{pro.trkind}}</td>
      <td data-column="Patient unit">{{pro.trnotes}}</td>
      <td data-column="Patient dos">{{pro.trstartdate}}</td>
        <td data-column="Patient date">
          <button name="BDrug" placeholder = "0" style="width: 50%;height: 35px;border-radius: 10%;color: rgb(2, 2, 114);" class="fa fa-pencil" required (click)="Selecthormonal(pro)"></button>
          <button name="BDrugn" placeholder = "0" style="width: 50%;height: 35px;border-radius: 10%;color: rgb(178, 0, 0)" class="fa fa-trash" required (click)="MesgDeleteLine(pro)"></button>
        </td>

        </tr>
  </tbody>
</table>
<div  *ngIf="!heddin_hormonal" class="styled-input" style="width: 1200px;">
  <div class="appointment-form-field"  style="width: 1200px;background-color: rgb(147, 147, 255);">
    <select id="department" name="unit" required="" style="width: 20%;" [(ngModel)]="trkindid"  >
      <option value="{{unit.prHdName}}" *ngFor="let unit of protocolHD; let i = index">{{unit.prHdName}}</option>
    </select>
    <input type="text" name="dos" style="width: 50%;" [(ngModel)]= "trnotes" />
    <input type="date" name="dosmod" style="width: 20%;" [(ngModel)]= "trstartdate" />
       <button name="BDrug" placeholder = "0" class="fa fa-floppy-o" style="color: rgb(2, 2, 114); width: 5%;height: 100%;border-radius: 10%;" (click)="submitHormonal()" required></button>
    <button name="BDrug1" placeholder = "0" class="fa fa-trash-o" style="color: rgb(178, 0, 0); width: 5%;height: 100%;border-radius: 10%;" (click)="MesgDelete()" required></button>
  </div>
</div>
<!-- ---------- End If Hormonal TTT --------------- -->
<!-- **************** Start If Sugry TTT ******************** -->
<table *ngIf="!heddin_surgry" style="width: 1200px;">
  <thead>
      <tr>

          <!-- <th style="background-color:  rgb(70, 70, 247);color: white;width: 20%;">Surgery Type</th> -->
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 60%;">{{TreatmentNotes}}</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 30%;">Start Date</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;">Select</th>

      </tr>
  </thead>
  <tbody>

    <tr *ngFor="let pro of surgrylist; let i = index" style="height: 50%;">
      <!-- <td data-column="Patient ID" >{{pro.trkind}}</td> -->
      <td data-column="Patient unit">{{pro.trnotes}}</td>
      <td data-column="Patient dos">{{pro.trstartdate}}</td>
        <td data-column="Patient date">
          <button name="BDrug" placeholder = "0" style="width: 50%;height: 35px;border-radius: 10%;color: rgb(2, 2, 114);" class="fa fa-pencil" required (click)="Selecthormonal(pro)"></button>
          <button name="BDrugn" placeholder = "0" style="width: 50%;height: 35px;border-radius: 10%;color: rgb(178, 0, 0)" class="fa fa-trash" required (click)="MesgDeleteLine(pro)"></button>
        </td>

        </tr>
  </tbody>
</table>
<div  *ngIf="!heddin_surgry" class="styled-input" style="width: 1200px;">
  <div class="appointment-form-field"  style="width: 1200px;background-color: rgb(147, 147, 255);">

    <!-- <input type="text" name="unit" style="width: 20%;" [(ngModel)]= "trkindid" /> -->
    <input type="text" name="dos" style="width: 60%;" [(ngModel)]= "trnotes" />
    <input type="date" name="dosmod" style="width: 30%;" [(ngModel)]= "trstartdate" />
    <button name="BDrug" placeholder = "0" class="fa fa-floppy-o" style="color: rgb(2, 2, 114); width: 5%;height: 100%;border-radius: 10%;" (click)="submitRadio()" required></button>
    <button name="BDrug1" placeholder = "0" class="fa fa-trash-o" style="color: rgb(178, 0, 0); width: 5%;height: 100%;border-radius: 10%;" (click)="MesgDelete()" required></button>
  </div>
</div>
<!-- ---------- End If Sugry TTT --------------- -->

<!-- **************** Start If Target TTT ******************** -->
<table *ngIf="!heddin_target" style="width: 1200px;">
  <thead>
      <tr>

          <th style="background-color:  rgb(70, 70, 247);color: white;width: 70%;">{{TreatmentNotes}}</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 20%;">Start Date</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;">Select</th>

      </tr>
  </thead>
  <tbody>

    <tr *ngFor="let pro of targetlist; let i = index" style="height: 50%;">

      <td data-column="Patient unit">{{pro.trnotes}}</td>
      <td data-column="Patient dos">{{pro.trstartdate}}</td>
        <td data-column="Patient date">
          <button name="BDrug" placeholder = "0" style="width: 50%;height: 35px;border-radius: 10%;color: rgb(2, 2, 114);" class="fa fa-pencil" required (click)="Selecthormonal(pro)"></button>
          <button name="BDrugn" placeholder = "0" style="width: 50%;height: 35px;border-radius: 10%;color: rgb(178, 0, 0)" class="fa fa-trash" required (click)="MesgDeleteLine(pro)"></button>
        </td>

        </tr>
  </tbody>
</table>
<div  *ngIf="!heddin_target" class="styled-input" style="width: 1200px;">
  <div class="appointment-form-field"  style="width: 1200px;background-color: rgb(147, 147, 255);">

    <input type="text" name="dos" style="width: 70%;" [(ngModel)]= "trnotes" />
    <input type="date" name="dosmod" style="width: 20%;" [(ngModel)]= "trstartdate" />
       <button name="BDrug" placeholder = "0" class="fa fa-floppy-o" style="color: rgb(2, 2, 114); width: 5%;height: 100%;border-radius: 10%;" (click)="submitTrget()" required></button>
    <button name="BDrug1" placeholder = "0" class="fa fa-trash-o" style="color: rgb(178, 0, 0); width: 5%;height: 100%;border-radius: 10%;" (click)="MesgDelete()" required></button>
  </div>
</div>
<!-- ---------- End If Target TTT --------------- -->
 <!-- **************** Start If Immuino TTT ******************** -->
<table *ngIf="!heddin_immuneo" style="width: 1200px;">
  <thead>
      <tr>

          <th style="background-color:  rgb(70, 70, 247);color: white;width: 70%;">{{TreatmentNotes}}</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 20%;">Start Date</th>
          <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;">Select</th>

      </tr>
  </thead>
  <tbody>

    <tr *ngFor="let pro of immuneolist; let i = index" style="height: 50%;">

      <td data-column="Patient unit">{{pro.trnotes}}</td>
      <td data-column="Patient dos">{{pro.trstartdate}}</td>
        <td data-column="Patient date">
          <button name="BDrug" placeholder = "0" style="width: 50%;height: 35px;border-radius: 10%;color: rgb(2, 2, 114);" class="fa fa-pencil" required (click)="Selecthormonal(pro)"></button>
          <button name="BDrugn" placeholder = "0" style="width: 50%;height: 35px;border-radius: 10%;color: rgb(178, 0, 0)" class="fa fa-trash" required (click)="MesgDeleteLine(pro)"></button>
        </td>

        </tr>
  </tbody>
</table>
<div  *ngIf="!heddin_immuneo" class="styled-input" style="width: 1200px;">
  <div class="appointment-form-field"  style="width: 1200px;background-color: rgb(147, 147, 255);">

    <input type="text" name="dos" style="width: 70%;" [(ngModel)]= "trnotes" />
    <input type="date" name="dosmod" style="width: 20%;" [(ngModel)]= "trstartdate" />
       <button name="BDrug" placeholder = "0" class="fa fa-floppy-o" style="color: rgb(2, 2, 114); width: 5%;height: 100%;border-radius: 10%;" (click)="submitTrget()" required></button>
    <button name="BDrug1" placeholder = "0" class="fa fa-trash-o" style="color: rgb(178, 0, 0); width: 5%;height: 100%;border-radius: 10%;" (click)="MesgDelete()" required></button>
  </div>
</div>
<!-- ---------- End If Immuino TTT --------------- -->

</div>
  <form style="width: 100%;text-align: center;">
    <label style="width: 25%;"></label>
    <button type="button" class="theme-button btn" style="width: 10%;height: 60px; font-weight: bold;background-color: rgb(0, 86, 0);color: white; border-style: none;height: 60%;" name="submit" (click)="New_Date()">{{ 'New Line' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 10%;height: 60px;font-weight: bold;background-color: rgb(1, 19, 58);color: white;border-style: none;height: 60%;" name="Back" (click)="Exit_Data()">{{ 'Home' | translate }}</button>
    <label style="width: 25%;"></label>
  </form>
  <BR>
</section>
</div>
</mat-dialog-content>


